import type { IMediumDto, ISession } from '@monofe/apiservice';

const downloadSize = (list: IMediumDto[]) =>
    Promise.resolve(
        list
            .map(medium => medium.mediumSize)
            .reduce((count, currentSize) => count + currentSize, 0),
    );

const downloadList = async (
    session: ISession,
    languageId: number,
    tourId: number,
): Promise<IMediumDto[]> => {
    if (!languageId || languageId <= 0) {
        return [];
    }

    if (!tourId || tourId <= 0) {
        return [];
    }

    const database = await session.db.open();
    const language = await database.get('ILanguageDto', languageId);
    const tour = await database.get('ITourDto', tourId);
    const allDownloadList = await session.media.mediaForLanguageWithTour(language, tour);
    database.close();

    const isCachedStatus = await Promise.all(
        allDownloadList.map(medium => session.media.isMediumCached(medium.id)),
    );

    const missingDownloadList = allDownloadList.filter(
        (value, index) => !(isCachedStatus[index] ?? false),
    );

    return missingDownloadList;
};

export default Object.freeze({
    downloadList,
    downloadSize,
});
